import React from "react";
import { FormattedMessage } from "react-intl";
import { SimpleTextInputCard } from "sortation/components/SimpleTextInputCard";
import { useShipToStoreLabelScan } from "./useShipToStoreLabelScan";

export const ShipToStoreLabelScan: React.FC = () => {
  const {
    barcode,
    setBarcode,
    handleShipToStoreLabelScan,
    handleShipToStoreLabelScanState,
  } = useShipToStoreLabelScan();
  return (
    <SimpleTextInputCard
      title={<FormattedMessage id="sortation.ShipToStoreLabel.title" defaultMessage="Scan Carton Barcode" />}
      label={<FormattedMessage id="sortation.ShipToStoreLabel.label" defaultMessage="Barcode" />}
      value={barcode}
      onSubmit={handleShipToStoreLabelScan}
      onChange={setBarcode}
      disabled={handleShipToStoreLabelScanState.loading}
      debounceSubsequent
    />
  );
};
